//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  queryUserServicePlans,
  mockRenewServicePlan,
  isServicePlanAllowed,
  createServicePlanWechatOrder,
  queryServicePlanOrderIsOk
} from '@/api/servicePlan'

export default {
  name: 'DeviceServiceList',
  data () {
    return {
      keyword: '',
      list: [],
      total: 0,
      normalCnt: 0,
      expiringCnt: 0,
      expiredCnt: 0,
      freeCnt: 0,
      loading: false,
      refreshing: false,
      imgArr: []
    }
  },
  computed: {
    filteredList () {
      if (!this.keyword) {
        return this.list
      }
      let kw = this.keyword.toLowerCase().trim()
      return this.list.filter(item => {
        let nameMatch = item.device_name && item.device_name.toLowerCase().includes(kw)
        let imeiMatch = item.device_id && item.device_id.toLowerCase().includes(kw)
        let iccidMatch = item.iccid && item.iccid.toLowerCase().includes(kw)
        return nameMatch || imeiMatch || iccidMatch
      })
    }
  },
  created () {
    if (!isServicePlanAllowed()) {
      this.$toast('该功能暂未对您的账号开放')
      this.$router.replace('/')
      return
    }
    if (this.common && this.common.getDeviceImg) {
      this.imgArr = this.common.getDeviceImg()
    }
    this.loadData()
  },
  mounted () {
    document.title = '设备服务期'
  },
  methods: {
    loadData () {
      this.loading = true
      queryUserServicePlans()
        .then(res => {
          this.loading = false
          this.refreshing = false
          if (res && res.data) {
            let data = res.data
            this.list = data.list || []
            this.total = data.total || 0
            this.normalCnt = data.normal_cnt || 0
            this.expiringCnt = data.expiring_cnt || 0
            this.expiredCnt = data.expired_cnt || 0
            this.freeCnt = data.free_cnt || 0
          }
        })
        .catch(err => {
          this.loading = false
          this.refreshing = false
          console.error('queryUserServicePlans err', err)
          this.$toast('获取设备服务期失败')
        })
    },
    onPullRefresh () {
      this.refreshing = true
      this.loadData()
    },
    handleManualRefresh () {
      this.loadData()
      this.$toast('已刷新服务期信息')
    },
    formatTime (tmStr) {
      if (!tmStr) return '--'
      return tmStr.length >= 10 ? tmStr.slice(0, 10) : tmStr
    },
    getValidDateText (item) {
      if (item.is_charge_enabled === 0 || item.expire_status === 'free') {
        return '终身免费保障'
      }
      if (item.service_expire_tm) {
        return item.service_expire_tm
      }
      return '待激活'
    },
    getBadgeClass (item) {
      if (item.is_charge_enabled === 0 || item.expire_status === 'free') {
        return 'badge-free'
      }
      switch (item.expire_status) {
        case 'normal':
          return 'badge-normal'
        case 'expiring':
          return 'badge-expiring'
        case 'expired':
          return 'badge-expired'
        default:
          return 'badge-normal'
      }
    },
    getBadgeText (item) {
      if (item.is_charge_enabled === 0 || item.expire_status === 'free') {
        return '免费保障'
      }
      switch (item.expire_status) {
        case 'normal':
          return '正常'
        case 'expiring':
          return `剩${item.days_left}天到期`
        case 'expired':
          return '已到期'
        default:
          return '正常'
      }
    },
    getRenewPreviewNotice (item) {
      if (!item.service_expire_tm) return ''
      let parts = item.service_expire_tm.split('-')
      if (parts.length < 3) return ''
      let expYear = parseInt(parts[0], 10)
      let expMonth = parseInt(parts[1], 10)
      let expDay = parseInt(parts[2], 10)
      let pad = n => (n < 10 ? '0' + n : '' + n)

      if (item.expire_status === 'expired') {
        let diffDays = typeof item.days_left !== 'undefined' ? item.days_left : -1
        if (diffDays >= -90) {
          let nextYearStr = (expYear + 1) + '-' + pad(expMonth) + '-' + pad(expDay)
          return `\n【续费规则】：服务已到期（3个月内），按原到期日顺延1年，续费后有效期至 ${nextYearStr}。`
        } else {
          let now = new Date()
          let nextYearStr = (now.getFullYear() + 1) + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate())
          return `\n【续费规则】：服务到期超3个月，重新起算1年，续费后有效期至 ${nextYearStr}。`
        }
      } else {
        let nextYearStr = (expYear + 1) + '-' + pad(expMonth) + '-' + pad(expDay)
        return `\n【续费规则】：提前顺延1年，续费后有效期至 ${nextYearStr}。`
      }
    },
    isFreeDevice (item) {
      if (!item) return false
      return item.is_charge_enabled === 0 || item.expire_status === 'free'
    },
    handleMockRenew (item) {
      if (this.isFreeDevice(item)) {
        this.$toast('该设备属于终身免费保障设备，无需续费')
        return
      }
      let notice = this.getRenewPreviewNotice(item)
      this.$dialog.confirm({
        title: '测试：模拟续费',
        message: `确定为设备【${item.device_name || item.device_id}】模拟续费 1 年吗？${notice}`
      }).then(() => {
        this.$toast.loading({ message: '续费处理中...', forbidClick: true })
        mockRenewServicePlan(item.did)
          .then(res => {
            this.$toast.clear()
            this.$toast.success('模拟续费成功！')
            this.loadData()
          })
          .catch(err => {
            this.$toast.clear()
            console.error('mockRenewServicePlan err', err)
            this.$toast('模拟续费失败')
          })
      }).catch(() => {})
    },
    formatFee (fee) {
      if (!fee || fee === 36 || fee === '36' || fee === '36.00') {
        return '15.00'
      }
      let num = parseFloat(fee)
      if (isNaN(num) || num <= 0) {
        return '15.00'
      }
      return num.toFixed(2)
    },
    handleRecharge (item) {
      if (this.isFreeDevice(item)) {
        this.$toast('该设备属于终身免费保障设备，无需续费')
        return
      }
      let openid = this.$store.getters.get_openid
      let feeStr = this.formatFee(item.fee_standard)
      let notice = this.getRenewPreviewNotice(item)
      this.$dialog.confirm({
        title: '流量卡年费续费',
        message: `设备：${item.device_name || item.device_id}\n${item.iccid ? '卡号：' + item.iccid + '\n' : ''}\n年费标准：¥${feeStr} / 年\n【测试特惠】：实付仅需 ¥0.01 元${notice}\n\n是否立即通过微信支付续费？`
      }).then(() => {
        if (!openid) {
          this.$dialog.alert({
            title: '提示',
            message: '未检测到微信授权信息(openid)，请在微信公众号客户端中打开进行支付。'
          })
          return
        }
        let host = window.location.host
        let urltag = host === 'aimtycloud.anfangwx.aimtyiot.cn' ? 1 : 2
        this.$toast.loading({ message: '正在创建微信订单...', forbidClick: true, duration: 0 })

        createServicePlanWechatOrder({
          did: item.did,
          openid: openid,
          urltag: urltag
        }).then(res => {
          this.$toast.clear()
          if (!res || !res.data || !res.data.appId) {
            this.$toast('拉起支付失败，请稍后重试')
            return
          }
          let payParam = res.data
          let outTradeNo = payParam.outTradeNo
          let vm = this

          if (typeof WeixinJSBridge === 'undefined') {
            this.$toast('请在微信内置浏览器中完成支付')
            return
          }

          // eslint-disable-next-line
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', payParam,
            function (wxRes) {
              if (wxRes.err_msg === 'get_brand_wcpay_request:ok') {
                vm.$toast.loading({ message: '支付成功，正在确认服务期...', forbidClick: true, duration: 3000 })
                queryServicePlanOrderIsOk({ out_trade_no: outTradeNo }).then(() => {
                  vm.$toast.clear()
                  vm.$toast.success('续费成功！服务期已顺延1年')
                  vm.loadData()
                }).catch(() => {
                  vm.$toast.clear()
                  vm.$toast.success('支付成功！服务期已更新')
                  vm.loadData()
                })
              } else if (wxRes.err_msg === 'get_brand_wcpay_request:cancel') {
                vm.$toast('支付已取消')
              } else {
                vm.$toast('支付失败: ' + (wxRes.err_desc || wxRes.err_msg))
              }
            }
          )
        }).catch(err => {
          this.$toast.clear()
          console.error('createServicePlanWechatOrder err', err)
          let msg = (err && err.message) || '预支付下单失败'
          this.$toast(msg)
        })
      }).catch(() => {})
    },
    getDeviceIcon (dtype) {
      if (this.imgArr && this.imgArr.length > 0) {
        let match = this.imgArr.find(r => r.dtype === dtype)
        if (match && match.imgUrl) {
          return match.imgUrl
        }
        return this.imgArr[this.imgArr.length - 1].imgUrl
      }
      return 'static/newDeviceIcon/index_default.png'
    },
    getDeviceTypeName (dtype) {
      let key = Number(dtype)
      let typeMap = {
        99: 'NB烟感',
        200: '一键报警器',
        300: '2G手表',
        301: '定位器',
        310: '4G手表',
        311: '4G手表',
        312: '4G手表',
        313: '4G健康手表',
        330: '4G胸卡定位',
        331: '4G拉绳报警器',
        332: '4G手表',
        350: '4G手表',
        351: '防拆手表',
        352: '防拆手表',
        353: '防拆手表',
        400: '智能门锁',
        401: '智能门锁',
        402: 'WiFi门磁',
        403: 'WiFi水浸',
        404: 'WiFi门磁',
        408: 'WiFi跌倒雷达',
        501: '一氧化碳',
        502: '燃气报警器',
        503: '压力传感器',
        504: '门磁报警器',
        505: 'SOS按钮',
        506: '烟感报警器',
        507: 'SOS按钮',
        508: '门磁报警器',
        509: '智能门锁',
        510: '水浸报警器',
        511: '断电监测器',
        512: '烟感报警器',
        533: '4G传感器',
        534: '4G传感器',
        536: '4G传感器',
        537: '4G-SOS按钮',
        538: '4G门磁',
        539: '4G水浸',
        540: '4G烟感',
        541: '4G燃气',
        542: '4G一氧化碳',
        543: '4G门磁',
        544: '4G水浸',
        545: '4G红外',
        546: '4G水压',
        601: '4G智能门锁',
        613: '4G智能门锁',
        700: '智能网关',
        701: '拉绳网关',
        750: '4G睡眠带',
        751: '4G温湿度',
        752: '4G感应雷达',
        753: '4G温湿度',
        754: '4G健康雷达',
        780: '4G跌倒雷达',
        800: '4G报警网关',
        850: '4G血压计',
        851: '4G血糖仪',
        852: '4G健康仪',
        901: '4G终端',
        902: '4G拉绳报警器',
        903: '4G终端',
        904: '4G断电报警器',
        905: '4G断电报警器',
        906: 'UPS设备',
        920: '4G语音呼叫器'
      }
      return typeMap[key] || ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/more/deviceServiceList.vue